'use strict'

import Vue from 'vue'
import axios from 'axios'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: process.env.VUE_APP_API_ROOT || process.env.apiUrl || '',
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

// _axios.interceptors.request.use(
//   function(config) {
//     // Do something before request is sent
//     return config;
//   },
//   function(error) {
//     // Do something with request error
//     return Promise.reject(error);
//   }
// );

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Only update token on successful responses (2xx status codes)
    if (response.status >= 200 && response.status < 300 && response.headers.authorization) {
      // Update the token with the new one provided to extend the session
      const token = response.headers.authorization.substring(7) // strip "Bearer "
      window.Vue.$auth.setToken({ access_token: token })
    }
    return response
  },
  function(error) {
    if (error.response && error.response.status === 401) {
      const { exp } = window.Vue.$auth.getPayload()
      const now = Math.floor(Date.now() / 1000)
      if (exp < now) {
        window.Vue.$store.dispatch('auth/logOut').then(() => {
          window.Vue.$router.push('/')
        })
        window.Vue.$store.dispatch('snackbarError', 'You have been logged out due to inactivity.')
      }
    }
    return Promise.reject(error)
  }
)

Plugin.install = function(Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      },
    },
    $axios: {
      get() {
        return _axios
      },
    },
    $http: {
      get() {
        return _axios
      },
    },
  })
}

Vue.use(Plugin)

export default Plugin
